"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _moment = _interopRequireDefault(require("moment"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _uiKit = require("@devsta/ui-kit");

require("../../../styles/import-script.scss");

var SCRIPT_HEIGHT = 115;
var getFilteredScripts = (0, _memoizeOne.default)(function (filter, scripts) {
  if (!filter) {
    return scripts;
  }

  return scripts.filter(function (script) {
    return Object.values(script).some(function (value) {
      return typeof value === 'string' && value.toLowerCase().includes(filter.toLowerCase());
    });
  });
});

function renderScriptPreview(_ref) {
  var content = _ref.content,
      name = _ref.name;
  return _react.default.createElement("div", {
    className: "import-script__preview"
  }, _react.default.createElement("p", null, _react.default.createElement("strong", null, name)), _react.default.createElement("p", null, content));
}

var ImportScriptModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ImportScriptModal, _Component);

  function ImportScriptModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ImportScriptModal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ImportScriptModal).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectScript", (0, _lodash.default)(function (index) {
      return function () {
        _this.setState(function (_ref2) {
          var selectedScriptIndex = _ref2.selectedScriptIndex;
          return {
            selectedScriptIndex: index === selectedScriptIndex ? undefined : index
          };
        });
      };
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangeFilter", function (_ref3) {
      var value = _ref3.target.value;

      _this.setState({
        filter: value
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "createScript", function () {
      var history = _this.props.history;
      history.push('/scripts');
    });
    _this.state = {
      filter: ''
    };
    return _this;
  }

  (0, _createClass2.default)(ImportScriptModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          visible = _this$props.visible,
          onClose = _this$props.onClose,
          onSave = _this$props.onSave,
          scripts = _this$props.scripts;
      var _this$state = this.state,
          selectedScriptIndex = _this$state.selectedScriptIndex,
          filter = _this$state.filter;
      var filteredScripts = getFilteredScripts(filter, scripts);
      var minContainerHeight = scripts.length > 3 ? SCRIPT_HEIGHT * 3 : scripts.length * SCRIPT_HEIGHT;
      return _react.default.createElement(_uiKit.FormModal, {
        className: "import-script",
        title: "Import Script",
        visible: visible,
        onClose: onClose,
        onSave: onSave(selectedScriptIndex),
        saveText: "IMPORT SELECTED",
        saveDisabled: selectedScriptIndex === void 0
      }, _react.default.createElement(_uiKit.Input, {
        prefix: "search",
        placeholder: "Search",
        onChange: this.onChangeFilter
      }), _react.default.createElement("div", {
        className: "import-script__scripts",
        style: {
          minHeight: minContainerHeight
        }
      }, !filteredScripts.length ? _react.default.createElement("div", {
        className: "import-script__scripts__empty"
      }, _react.default.createElement("p", null, "There aren't any scripts. ".concat(filter ? 'Try clearing your search, or' : '')), _react.default.createElement(_uiKit.Button, {
        onClick: this.createScript
      }, "Create a Script")) : null, filteredScripts.map(function (_ref4, index) {
        var name = _ref4.name,
            updatedAt = _ref4.updatedAt,
            scriptId = _ref4.scriptId,
            content = _ref4.content;
        return _react.default.createElement("div", {
          key: scriptId,
          className: "import-script__script"
        }, renderScriptPreview({
          name: name,
          content: content
        }), _react.default.createElement("div", null, _react.default.createElement("h2", null, name || 'New Script'), _react.default.createElement("p", {
          className: "import-script__script__updated"
        }, "Updated:", " ".concat((0, _moment.default)(updatedAt, 'x').fromNow()))), _react.default.createElement(_uiKit.Button, {
          onClick: _this2.selectScript(index),
          type: selectedScriptIndex === index ? 'PRIMARY' : 'INVERTED',
          small: true
        }, selectedScriptIndex === index ? 'DESELECT' : 'SELECT'));
      })));
    }
  }]);
  return ImportScriptModal;
}(_react.Component);

var _default = ImportScriptModal;
exports.default = _default;